import {
  get,
  post,
  del,
  put,
  getfile
} from '@/http/request'
import {
  HOST
} from '@/http/config'


// 新增通知
export function addPartyNotice(params) {
  return post(`${HOST}party_notice/save`, params)
}
// 修改通知
export function updatePartyNotice(params) {
  return put(`${HOST}party_notice/put`, params)
}
//短信列表
export function smsNoticeList(params) {
  return get(`${HOST}sms-notice/list`, params)
}
//短信新增
export function smsNoticeSave(params) {
  return post(`${HOST}sms-notice/save`, params)
}
//获取短信分组列表
export function getSMSGroupList(params) {
  return get(`${HOST}sms-group/list`, params)
}

/**
 * 短信分组列表接口
 */
//获取短信分组列表
// export function getSMSGroupList(params) {
//   return get(`${HOST}sms-group/list`, params)
// }
// 短息详情
export function getGroupDetial(params) {
  return get(`${HOST}sms-group/get`, params)
}
//添加短信分组
export function addSMSGroup(params) {
  return post(`${HOST}sms-group/save`, params)
}

//修改短信分组
export function updateSMSGroup(params) {
  return post(`${HOST}sms-group/update`, params)
}

// 删除分组
export function delSMSGroup(params) {
  return del(`${HOST}sms-group/delete`, params)
}

//组织结构树
export function getTreeList(params) {
  return get(`${HOST}organization-info/treeList/`, params)
}

//获取全部部门
export function getOrgIds() {
  return get(`${HOST}sys-group/getOrgIds`)
}

//用户列表
export function getUser(params) {
  return get(`${HOST}sys-user/list`, params)
}

// 下载发送结果
export function smsNoticeExport(params) {
  return getfile(`${HOST}sms-notice/export`, params)
}

//短信分组列表接口end//



// WEBPACK FOOTER //
// ./src/views/shortMessage/api/api.js